<template>
  <v-text-field
    :value="email"
    class="phone-input"
    color="deep-orange"
    :label="label"
    :placeholder="placeholder"
    v-on="$listeners"
    v-bind="{ ...$attrs, ...$props }"
    large
    :rules="[ValidationRules.requiredString, ValidationRules.emailRule]"
  />
</template>

<script>
import ValidationRules from '@/constants/ValidationRules'
export default {
  name: 'EmailField',
  components: {},
  props: {
    value: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: 'Email',
    },
    placeholder: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      email: '',
      ValidationRules,
    }
  },
}
</script>
